import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { CKEditor } from 'ckeditor4-react'
import parse from 'html-react-parser'

//antd
import { Input, Button, Row, notification, Form, Upload, Drawer, Select, InputNumber } from 'antd'

//icons
import { PlusOutlined } from '@ant-design/icons'

//apis
import { addSouvenir, updateSouvenir } from 'apis/souvenir'
import { uploadFile } from 'apis/upload'

export default function SouvenirForm({
  reloadData,
  children,
  infoBranch,
  countries = [],
  regions = [],
  taxList = [],
}) {
  const [form] = Form.useForm()
  const dataUser = useSelector((state) => state.navigation)

  const [loading, setLoading] = useState(false)
  const [description, setDescription] = useState('')
  const [imageView, setImageView] = useState('')
  const [visible, setVisible] = useState(false)

  const toggle = () => {
    setVisible(!visible)
  }

  const _addOrUpdateSouvenir = async () => {
    try {
      await form.validateFields()
      const formData = form.getFieldsValue()

      if (!imageView) {
        notification.warning({ message: 'Vui lòng tải lên ít nhất 1 hình ảnh' })
        return
      }

      const body = {
        length: '',
        unit_of_length: '',
        width: '',
        height: '',
        weight: '',
        unit_of_mass: '',
        file_urls: [],
        warranties: [],
        deal_ids: [],
        category_ids: [],
        attributes: [
          {
            option: '',
            values: [''],
          },
        ],
        product_tag_ids: [],
        unit_ids: [],
        video_urls: [],
        meta_description: '',
        meta_keyword: '',
        meta_title: '',
        avatar: '',
        ...formData,
        name: formData.name,
        image_urls: imageView ? [imageView] : [],
        description: description || '',
        user_id: dataUser && dataUser.data.user_id,
        is_souvenir: true,
        priority: formData.priority || 0,
        variants: [
          {
            image_urls: imageView ? [imageView] : [],
            options: [''],
            prices: [
              {
                max_quantity_apply: 20,
                min_quantity_apply: 1,
                price: formData.price,
              },
            ],
            sku: '',
            title: formData.name,
            video_urls: [],
          },
        ],
      }

      setLoading(true)
      let res
      if (infoBranch) res = await updateSouvenir(body, infoBranch.product_id)
      else res = await addSouvenir(body)
      setLoading(false)

      if (res.status === 200) {
        if (res.data.success) {
          reloadData()
          notification.success({
            message: `${infoBranch ? 'Cập nhật' : 'Tạo'} quà lưu niệm thành công`,
          })
          toggle()
        } else
          notification.error({
            message:
              res.data.message ||
              `${infoBranch ? 'Cập nhật' : 'Tạo'} quà lưu niệm thất bại, vui lòng thử lại!`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${infoBranch ? 'Cập nhật' : 'Tạo'} quà lưu niệm thất bại, vui lòng thử lại!`,
        })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  //reset
  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setDescription('')
      setImageView('')
    } else {
      if (infoBranch) {
        form.setFieldsValue({
          ...infoBranch,
          price: infoBranch?.variants[0]?.prices[0]?.price || '',
        })
        setImageView(
          infoBranch.image_urls && infoBranch.image_urls.length ? infoBranch.image_urls[0] : ''
        )
        setDescription(infoBranch.description || '')
      }
    }
  }, [visible])

  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      <Drawer
        title={infoBranch ? 'Cập nhật quà lưu niệm' : 'Thêm quà lưu niệm'}
        centered
        width="50%"
        footer={
          <Row justify="end">
            <Button loading={loading} size="large" type="primary" onClick={_addOrUpdateSouvenir}>
              {infoBranch ? 'Cập nhật' : 'Thêm'}
            </Button>
          </Row>
        }
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Upload
            listType="picture-card"
            className="upload-category-image"
            showUploadList={false}
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            data={async (file) => {
              setLoading(true)
              const url = await uploadFile(file)
              setLoading(false)
              if (url) setImageView(url)
            }}
          >
            {imageView ? (
              <img src={imageView} alt="avatar" style={{ width: '100%' }} />
            ) : (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            )}
          </Upload>
          <br />
          <Form.Item
            name="name"
            label="Tên quà lưu niệm"
            rules={[{ required: true, message: 'Vui lòng nhập tên quà lưu niệm!' }]}
          >
            <Input size="large" style={{ width: '100%' }} placeholder="Nhập tên quà lưu niệm" />
          </Form.Item>
          <Form.Item
            name="price"
            label="Giá tiền"
            rules={[{ required: true, message: 'Vui lòng nhập giá tiền!' }]}
          >
            <InputNumber
              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              placeholder="Nhập giá tiền"
              min={0}
              size="large"
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label="Thuế"
            name="tax_ids"
            rules={[{ required: true, message: 'Vui lòng chọn ít nhất mốt thuế!' }]}
          >
            <Select
              maxTagCount="responsive"
              allowClear
              mode="multiple"
              size="large"
              placeholder="Chọn thuế"
              showSearch
              optionFilterProp="children"
            >
              {taxList.map((tax, index) => (
                <Select.Option key={index} value={tax.tax_id}>
                  {tax.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="priority"
            label="Độ ưu tiên"
            rules={[{ required: true, message: 'Vui lòng nhập độ ưu tiên!' }]}
          >
            <InputNumber size="large" style={{ width: '100%' }} placeholder="Nhập độ ưu tiên" />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
            label="Quốc gia"
            name="country_ids"
          >
            <Select
              maxTagCount="responsive"
              mode="multiple"
              size="large"
              allowClear
              optionFilterProp="children"
              showSearch
              placeholder="Chọn quốc gia"
            >
              {countries.map((country, index) => (
                <Select.Option key={index} value={country.country_id}>
                  {country.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: 'Vui lòng chọn khu vực' }]}
            label="Khu vực"
            name="region_ids"
          >
            <Select
              maxTagCount="responsive"
              mode="multiple"
              size="large"
              allowClear
              optionFilterProp="children"
              showSearch
              placeholder="Chọn khu vực"
            >
              {regions.map((region, index) => (
                <Select.Option key={index} value={region.region_id}>
                  {region.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <div>
            <div>Giới thiệu</div>
            <CKEditor
              initData={infoBranch && parse(infoBranch.description || '')}
              onChange={(e) => setDescription(e.editor.getData())}
            />
          </div>
        </Form>
      </Drawer>
    </>
  )
}
